import React from "react";
import TripCard from "./TripCard";

export default function TripList({
  trips,
  selectedTripId,
  menuOpenId,
  menuRefs,
  onSelectTrip,
  onMenuToggle,
  onOpenBookingDetails,
  onPhoneCancel,
  onPrepareCancel,
  onUndoCancel,
}) {
  return (
    <div className="array-list">
      {trips.map((trip) => (
        <TripCard
          key={trip.id}
          trip={trip}
          trips={trips}
          selectedTripId={selectedTripId}
          menuOpenId={menuOpenId}
          menuRefs={menuRefs}
          onSelectTrip={onSelectTrip}
          onMenuToggle={onMenuToggle}
          onOpenBookingDetails={onOpenBookingDetails}
          onPhoneCancel={onPhoneCancel}
          onPrepareCancel={onPrepareCancel}
          onUndoCancel={onUndoCancel}
        />
      ))}
    </div>
  );
}
